/* eslint-disable */
class Time {
    constructor({ currTime, minTime, maxTime } = {}) {
        this.currTime = { year: '', month: '', day: '', hour: '' };
        this.currDate = null;
        this.minTime = { year: '', month: '', day: '', hour: '' };
        this.minDate = null;
        this.maxTime = { year: '', month: '', day: '', hour: '' };
        this.maxDate = null;

        this.timeArr = { year: [], month: [], day: [], hour: [] };
        this.timeIndex = { year: '', month: '', day: '', hour: '' };

        this.initTimePicker(currTime, minTime, maxTime);
    }

    initTimePicker(currTime, minTime, maxTime) {
        this.setCurrTime(currTime);
        this.setMinTime(minTime);
        this.setMaxTime(maxTime);
        this.setTimeArr();
    }
    setCurrTime(currTime) {
        if (currTime) { this.currDate = new Date(currTime.replace(/\-/g, '/')) } else { this.currDate = new Date() }
        this.currTime = this.getTimeObj(this.currDate, 'currDate');
    }
    setMinTime(minTime) {
        if (minTime) { this.minDate = new Date(minTime.replace(/\-/g, '/')) } else { this.minDate = new Date(this.currTime.year - 10, 0) }
        this.minTime = this.getTimeObj(this.minDate, 'minDate');
    }
    setMaxTime(maxTime) {
        if (maxTime) { this.maxDate = new Date(maxTime.replace(/\-/g, '/')) } else { this.maxDate = new Date(this.currTime.year + 10, 11, 31, 23) }
        this.maxTime = this.getTimeObj(this.maxDate, 'maxDate');
    }
    setTimeArr() {
        this.setYearArr(this.currTime.year);
        this.setMonthArr(this.currTime.month);
        this.setDayArr(this.currTime.day);
        this.setHourArr(this.currTime.hour);
    }

    changeCurrTime(currTime) {
        if (!currTime) return;
        this.setCurrTime(currTime);
        this.setTimeArr();
    }
    changeMinTime(minTime) {
        if (!minTime) return;
        this.setMinTime(minTime);
        this.setTimeArr();
    }
    changeMaxTime(maxTime) {
        if (!maxTime) return;
        this.setMaxTime(maxTime);
        this.setTimeArr();
    }

    getTimeObj(date, dateKey) {
        let _this = this;
        return new Proxy({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            hour: date.getHours(),
        }, {
            set(target, key, value, receiver) {
                target[key] = value;
                _this[dateKey] = new Date(target.year, target.month - 1, target.day, target.hour);
                return true;
            },
        });
    }
    getTimeMaxIndex() {
        let timeMaxIndex = {};
        Object.entries(this.timeArr).forEach(([key, value]) => {
            timeMaxIndex[key] = value.length - 1;
        });
        return timeMaxIndex;
    }
    getTimeMinMax() {
        let timeMinMax = {};
        Object.entries(this.timeArr).forEach(([key, value]) => {
            timeMinMax[key] = {
                min: value[0],
                max: value[value.length - 1],
            };
        });
        return timeMinMax;
    }

    setYearArr(currYear) {
        let minYear = this.minTime.year;
        let maxYear = this.maxTime.year;
        let arrLen = maxYear - minYear + 1;
        let yearArr = Array(arrLen).fill(null);
        this.timeArr.year = yearArr.map((value, index) => {
            value = minYear + index;
            if (value === currYear) {
                this.currTime.year = value;
                this.timeIndex.year = index;
            }
            return value;
        });
    }
    changeYear(year, index) {
        let timeMinMax = this.getTimeMinMax();
        let currMonth = this.currTime.month;
        if (currMonth === 2) {
            let monthMaxDay = this.getMonthMaxDay(new Date(year, currMonth - 1));
            let currDay = this.currTime.day;
            if (currDay > monthMaxDay) {
                this.currTime.day = monthMaxDay;
                this.timeIndex.day = this.timeIndex.day - 1;
            }
        }
        this.currTime.year = year;
        this.timeIndex.year = index;
        this.changeMonthArr(timeMinMax);
    }
    changeMonthArr(preTimeMinMax) {
        let { min: preMinMonth, max: preMaxMonth } = preTimeMinMax.month;
        let { minMonth, maxMonth } = this.getMinMaxMonth();
        if (preMinMonth !== minMonth || preMaxMonth !== maxMonth) {
            this.setMonthArr(this.currTime.month);
            this.changeDayArr(preTimeMinMax);
        } else if (this.currTime.month === 2) {
            this.changeDayArr(preTimeMinMax);
        }
    }
    setMonthArr(currMonth) {
        let { minMonth, maxMonth } = this.getMinMaxMonth();
        if (currMonth < minMonth) currMonth = minMonth;
        if (currMonth > maxMonth) currMonth = maxMonth;
        let arrLen = maxMonth - minMonth + 1;
        let monthArr = Array(arrLen).fill(null);
        this.timeArr.month = monthArr.map((value, index) => {
            value = minMonth + index;
            if (value === currMonth) {
                this.currTime.month = value;
                this.timeIndex.month = index;
            }
            return value;
        });
    }
    getMinMaxMonth() {
        let minMonth = 1;
        let maxMonth = 12;
        let timeMaxIndex = this.getTimeMaxIndex();
        if (this.timeIndex.year <= 0) minMonth = this.minTime.month;
        if (this.timeIndex.year >= timeMaxIndex.year) maxMonth = this.maxTime.month;
        return { minMonth, maxMonth };
    }
    changeMonth(month, index) {
        let timeMinMax = this.getTimeMinMax();
        let monthMaxDay = this.getMonthMaxDay(new Date(this.currTime.year, month - 1));
        let currDay = this.currTime.day;
        if (currDay > monthMaxDay) {
            this.currTime.day = monthMaxDay;
            this.timeIndex.day = this.timeIndex - (currDay - monthMaxDay);
        }
        this.currTime.month = month;
        this.timeIndex.month = index;

        this.changeDayArr(timeMinMax);
    }
    changeDayArr(preTimeMinMax) {
        let { min: preMinDay, max: preMaxDay } = preTimeMinMax.day;
        let { minDay, maxDay } = this.getMinMaxDay();
        if (preMinDay !== minDay || preMaxDay !== maxDay) {
            this.setDayArr(this.currTime.day);
            this.changeHourArr(preTimeMinMax);
        }
    }
    setDayArr(currDay) {
        let { minDay, maxDay } = this.getMinMaxDay();
        if (currDay < minDay) currDay = minDay;
        if (currDay > maxDay) currDay = maxDay;
        let arrLen = maxDay - minDay + 1;
        let dayArr = Array(arrLen).fill(null);
        this.timeArr.day = dayArr.map((value, index) => {
            value = minDay + index;
            if (value === currDay) {
                this.currTime.day = value;
                this.timeIndex.day = index;
            }
            return value;
        });
    }
    getMinMaxDay() {
        let minDay = 1;
        let maxDay = this.getMonthMaxDay(this.currDate);
        let { year: yearMaxIndex, month: monthMaxIndex } = this.getTimeMaxIndex();
        let { year: yearIndex, month: monthIndex } = this.timeIndex;
        if (yearIndex <= 0 && monthIndex <= 0) minDay = this.minTime.day;
        if (yearIndex >= yearMaxIndex && monthIndex >= monthMaxIndex) maxDay = this.maxTime.day;
        return { minDay, maxDay };
    }
    changeDay(day, index) {
        let timeMinMax = this.getTimeMinMax();
        this.currTime.day = day;
        this.timeIndex.day = index;
        this.changeHourArr(timeMinMax);
    }
    changeHourArr(preTimeMinMax) {
        let { min: preMinHour, max: preMaxHour } = preTimeMinMax.hour;
        let { minHour, maxHour } = this.getMinMaxHour();
        if (preMinHour !== minHour || preMaxHour !== maxHour) {
            this.setHourArr(this.currTime.hour);
        }
    }
    setHourArr(currHour) {
        let { minHour, maxHour } = this.getMinMaxHour();
        if (currHour < minHour) currHour = minHour;
        if (currHour > maxHour) currHour = maxHour;
        let arrLen = maxHour - minHour + 1;
        let hourArr = Array(arrLen).fill(null);
        this.timeArr.hour = hourArr.map((value, index) => {
            value = minHour + index;
            if (value === currHour) {
                this.currTime.hour = currHour;
                this.timeIndex.hour = index;
            }
            return value;
        });
    }
    getMinMaxHour() {
        let minHour = 0;
        let maxHour = 23;
        let { year: yearMaxIndex, month: monthMaxIndex, day: dayMaxIndex } = this.getTimeMaxIndex();
        let { year: yearIndex, month: monthIndex, day: dayIndex } = this.timeIndex;
        if (yearIndex <= 0 && monthIndex <= 0 && dayIndex <= 0) minHour = this.minTime.hour;
        if (yearIndex >= yearMaxIndex && monthIndex >= monthMaxIndex && dayIndex >= dayMaxIndex) maxHour = this.maxTime.hour;
        return { minHour, maxHour };
    }
    changeHour(hour, index) {
        this.currTime.hour = hour;
        this.timeIndex.hour = index;
    }

    getMonthMaxDay(date) {
        let month = date.getMonth() + 1;
        switch (month) {
            case 1:
            case 3:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
                return 31;
            case 4:
            case 6:
            case 9:
            case 11:
                return 30;
            case 2:
                return this.isLeapYear(date) ? 29 : 28;
        }
    }
    isLeapYear(date) {
        return (date.getYear() % 4 === 0 && ((date.getYear() % 100 !== 0) || (date.getYear() % 400 === 0)));
    }
}

export default Time;
